import React, { Component } from 'react';
import { getAreaNames } from '../../API/FetchCall';
import { FormGroup, Label, Input } from "reactstrap";
import Autosuggest from 'react-autosuggest';
import { Link } from 'react-router-dom';
import { BASE_URL, IMG_URL } from '../../constant';

class LeadSmall extends React.Component {
    constructor(props) {
        super(props);
        console.log('this.props', window.location.pathname)
        this.state = {
            user_id: '',
            location: localStorage.getItem('current_location') ? localStorage.getItem('current_location') : 'Bengaluru',
            vertical:this.props.pageinfo,
            suggestions: [],
            locationselected:false,
            contentList: [],
            locality:'' 
        };
        this.handleChangeCity = this.handleChangeCity.bind(this);
         
    }

    componentDidMount() {
        let THIS = this;
        let auth = localStorage.getItem("logged_auth");
        let data_auth = (localStorage.getItem("myData"));
        if (data_auth) {
            let auth_data = JSON.parse(data_auth)
            this.setState({
                logged_name: auth_data.first_name + ' ' + auth_data.last_name,
                authe: true,
                user_id: auth_data.user_id,
            });
        }
     
        
        this.onSuggestionSelected = this.onSuggestionSelected.bind(this);

    }


    /* suggestion*/

  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  onSuggestionsFetchRequested = ({ value }) => {

    const val = this.escapeRegexCharacters(value.trim());
    let fetch = JSON.stringify({
      city: this.state.city,
      keyword:val
    });
    getAreaNames(fetch).then(res => {
      if (res.status == 1) {
        this.setState({
          suggestions: res.list
        });
      }
    });
  };

  onSuggestionSelected = (event, { suggestion, suggestionValue, index, method }) => {
      console.log('ping... ', suggestion)

      this.setState({
          latitude: suggestion.latitude,
          longtitude: suggestion.longtitude,
          isSuggested:true,
          locationselected:true
      });


  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  getSuggestionValue = (suggestion) => {
    return suggestion.name;
  }

  renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }

  onAutoSuggestChange = (event, { newValue, method }) => {
    this.setState({
      locality: newValue,
      isSuggested:false
    });
  };

 

  handleChangeCity(event) {
    
    const { name, value } = event.target;

    this.setState({
      [name]: value
    });

    if(value=='others'){
      this.setState({isothers:true})
    }else{
      this.setState({isothers:false})
    }

  }  

  render() {

        const inputPropsD = {
        value: this.state.locality,
        onChange: this.onAutoSuggestChange,
        name: 'locality',
        className: 'form-control'
      };
        
        const {value, suggestions, city, isothers, localities, fromblog, fromvertical, subcat2, vertical} = this.state;

        return (
            <React.Fragment>
                <div>
                   
                    <div className="left-side-box">
                        <div className="left-head trend-head" id="articles_section"> Find {this.props.pageinfo.parent} near me </div>
                        <div className="left-side-body">
                        <div class="lookupform">
                        <div class="row">
                        <div class="col-md-12 col-sm-12">
                        <Label for="location">My City</Label>
                        <select name="city"  class="form-control form-control-sm"
                          id="city" onChange={this.handleChangeCity}>
                          <option value="">Choose your city</option>
                          <option value="bengaluru">Bengaluru</option>
                          <option value="chennai">Chennai</option>
                          <option value="others">Others</option>
                        </select>
                        </div>

                        <div class="col-md-12 col-sm-12">
                        {this.state.city!='others' && 
                        <> 
                        <Label for="location">My Locality</Label>
                        <Autosuggest 
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        onSuggestionSelected={this.onSuggestionSelected}
                        inputProps={inputPropsD} 
                        />
                        </> 

                        }
                        </div>

                        <div class="col-md-12 col-sm-12">
                            <div class="btnaligned" className={(this.state.locationselected) ? "btnaligned":"btnaligned hidden"}>
                            {(this.props.pageinfo.fromvertical=='school' || this.props.pageinfo.fromvertical=='community-support' || this.props.pageinfo.fromvertical=='learning-camps' || this.props.pageinfo.fromblog=='schoolblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-schools-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            }>Next</Link>

                            )}

                            {(
                                
                                this.props.pageinfo.fromvertical=='boarding-schools' ||
                                this.props.pageinfo.fromvertical=='private-schools' ||
                                this.props.pageinfo.fromvertical=='public-schools' ||
                                this.props.pageinfo.fromvertical=='international-schools' ||
                                this.props.pageinfo.fromvertical=='school-special-needs' ||
                                this.props.pageinfo.fromvertical=='alternative-schools') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-schools-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='tuitions' || this.props.pageinfo.fromblog=='tuitionblogs') && (    
                            
                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-tuitions-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='maths' ||
                              this.props.pageinfo.fromvertical=='science' ||
                              this.props.pageinfo.fromvertical=='accounts' ||
                              this.props.pageinfo.fromvertical=='economics' ||
                              this.props.pageinfo.fromvertical=='comp-exams' ||
                              this.props.pageinfo.fromvertical=='business-studies' ||
                              this.props.pageinfo.fromvertical=='languages' ||
                              this.props.pageinfo.fromvertical=='social-science') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-tuitions-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}
                        
                            {(this.props.pageinfo.fromvertical=='preschool' ||
                              this.props.pageinfo.fromvertical=='montessori' ||
                              this.props.pageinfo.fromvertical=='kindergarten' ||
                              this.props.pageinfo.fromvertical=='play-group' ||
                              this.props.pageinfo.fromvertical=='special-needs' ||
                              this.props.pageinfo.fromvertical=='day-care-or-creche') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-preschools-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}



                            {(this.props.pageinfo.fromvertical=='sports' || this.props.pageinfo.fromblog=='sportsblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-sports-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='music' || this.props.pageinfo.fromblog=='musicblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-music-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='preschool' || this.props.pageinfo.fromvertical=='birthday-event' || this.props.pageinfo.fromvertical=='kids-play-area' || this.props.pageinfo.fromblog=='preschoolblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-preschools-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='dance'  || this.props.pageinfo.fromvertical=='dance-and-theatre' || this.props.pageinfo.fromblog=='danceblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-dance-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='arts'  || this.props.pageinfo.fromvertical=='creative-arts'  || this.props.pageinfo.fromblog=='artblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-arts-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='skills' || this.props.pageinfo.fromvertical=='mind-and-skill-enrichment' || this.props.pageinfo.fromblog=='skillblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-skill-enrichment-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            {(this.props.pageinfo.fromvertical=='hobbies' || this.props.pageinfo.fromvertical=='hobbies-and-passion' || this.props.pageinfo.fromblog=='hobbiesblogs') && (

                            <Link class="btn btn-primary btn-sm" to={

                                {

                                    pathname:'/best-hobby-passion-enriching-classes-near-me',
                                    state:{
                                        city:this.state.city,
                                        location:this.state.locality,
                                        latitude:this.state.latitude,
                                        longtitude:this.state.longtitude,
                                        isSuggested:this.state.isSuggested,
                                        step:2
                                    }
                                }

                            } >Next</Link>

                            )}

                            </div>

                            </div>
                        </div>
                        </div>

                        </div>
                    </div>
                  
                </div>
                
            </React.Fragment >
        );
    }
}
export { LeadSmall };
